import React from "react";
import FinancingPlanInputPdf from "./financingPlanInputPdf/FinancingPlanInputPdf";
import "./FinancingPlanPdf.css";
import { formatNumberWithSpaces } from "../../../utils/Utils";

function FinancingPlanFdcPdf({ financingPlan }) {
  if (!financingPlan) return <></>;
  return (
    <>
      <div className='pf-pdf-top'>
        <div className='pf-pdf-card'>
          <div className='pf-pdf-card-header'>BESOINS</div>
          <FinancingPlanInputPdf label='Prix du fonds' value={financingPlan.prix_vente} />
          <FinancingPlanInputPdf label='Stocks à reprendre' value={financingPlan.stocks} />
          <FinancingPlanInputPdf
            label='Honoraires juridiques (en moyenne 3% du prix de vente)'
            value={financingPlan.honoraires_juridiques}
          />
          <FinancingPlanInputPdf label="Droits d'enregistrement" value={financingPlan.droits_enregistrement} />
          <FinancingPlanInputPdf
            label='Fonds de roulement (trésorerie de démarrage)'
            value={financingPlan.fonds_roulement}
          />
          <FinancingPlanInputPdf label='Travaux' value={financingPlan.travaux} />
          <FinancingPlanInputPdf label='Matériel & agencements' value={financingPlan.materiel_agencements} />
          {financingPlan.inputs.postes.map((poste, index) => (
            <FinancingPlanInputPdf label={poste.label} value={poste.value} key={index} />
          ))}
          <div className='pf-pdf-card-footer'>
            TOTAL À FINANCER
            <div className='pdf-pdf-input-value'>{formatNumberWithSpaces(financingPlan.total_a_financer, 1, "€")}</div>
          </div>
        </div>
        <div className='pf-pdf-card second'>
          <div className='pf-pdf-card-header'>RESSOURCES</div>
          <FinancingPlanInputPdf
            label='Apport financier (% du total à financer)'
            value={financingPlan.ratio_apport_financier}
            icon='%'
          />
          <FinancingPlanInputPdf label="Montant de l'apport" value={financingPlan.apport_financier} />
          {financingPlan.inputs.apports.map((apports, index) => (
            <FinancingPlanInputPdf label={apports.label} value={apports.value} key={index} />
          ))}
          <FinancingPlanInputPdf label='Montant à emprunter sur 7 ans' value={financingPlan.montant_sept_ans} />
          <FinancingPlanInputPdf label="Taux d'emprunt (TAEG)" value={financingPlan.taux_emprunt} icon='%' />
          <div className='pf-pdf-card-footer'>
            TOTAL FINANCÉ
            <div className='pdf-pdf-input-value'>{formatNumberWithSpaces(financingPlan.total_finance, 1, "€")}</div>
          </div>
        </div>
      </div>
      <div possible-page-break='true' />
      <div className='pf-pdf-title' style={{ "--background-color": "var(--sky-blue)" }}>
        LA RENTABILITÉ DÉGAGÉE PAR L'AFFAIRE
      </div>
      <FinancingPlanInputPdf
        label="EBE retraité (avant cotisations de l'exploitant)"
        value={financingPlan.ebe_retraite}
      />
      <div possible-page-break='true' />
      <div className='pf-pdf-title' style={{ "--background-color": "var(--blue)" }}>
        ...SERT À REMBOURSER LE PRÊT SUR L'ACHAT DU FONDS DE COMMERCE...
      </div>
      <FinancingPlanInputPdf
        label='Remboursement annuel du crédit (annuité capital + intérêts)'
        value={financingPlan.rbs_credit}
      />
      <div possible-page-break='true' />
      <div className='pf-pdf-title' style={{ "--background-color": "var(--dark-blue)" }}>
        ...ET PERMET AU REPRENEUR DE SE RÉMUNÉRER, PAYER SA PROTECTION SOCIALE ET SES IMPÔTS
      </div>
      <FinancingPlanInputPdf label='Reste à vivre annuel avant imposition' value={financingPlan.reste_a_vivre} />
      <div possible-page-break='true' />
      <div className='pf-pdf-title' style={{ "--color": "var(--black)", "--background-color": "var(--beige)" }}>
        SIMULATION DE REVENUS ANNUELS NETS APRÈS COTISATIONS SOCIALES (à titre indicatif)
      </div>
      <div className='pf-pdf-fdc-bottom'>
        <div className='row'>
          <div className='w-100'>
            <div className='pdf-pdf-input-label'>Repreneur en statut TNS à l'IS</div>
            <div className='pf-pdf-fdc-bottom-card'>
              <FinancingPlanInputPdf
                label={`Cotisations sociales annuelles (${financingPlan.ratio_cot_sociales_tns}%)`}
                value={financingPlan.cot_sociales_tns}
              />
              <FinancingPlanInputPdf
                label='Rémunération annuelle nette avant imposition personnelle'
                value={financingPlan.rem_nette_tns}
              />
              <FinancingPlanInputPdf
                label='Soit une rémunération mensuelle nette de'
                value={Math.round(financingPlan.rem_nette_tns / 12)}
              />
            </div>
          </div>
          <div className='w-100'>
            <div className='pdf-pdf-input-label'>Repreneur en statut salarié</div>
            <div className='pf-pdf-fdc-bottom-card'>
              <FinancingPlanInputPdf
                label={`Cotisations sociales annuelles (${financingPlan.ratio_cot_sociales_salarie}%)`}
                value={financingPlan.cot_sociales_salarie}
              />
              <FinancingPlanInputPdf
                label='Rémunération annuelle nette avant imposition personnelle'
                value={financingPlan.rem_nette_salarie}
              />
              <FinancingPlanInputPdf
                label='Soit une rémunération mensuelle nette de'
                value={Math.round(financingPlan.rem_nette_salarie / 12)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FinancingPlanFdcPdf;
